export default {
    allCompanies: {},
    companyShow: {},
}